import { join } from 'path'
import {FC, useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    reviewers: any[]
    approvers: any[]
}

export const ApprovalHistory: FC<Props> = ({
    reviewers,
    approvers
}) => {

    const bgStatuses = [
        {
            status: 'reviewer',
            bg: '#eee',
            color: '',
            icon: 'clock'
        },
        {
            status: 'reviewed',
            bg: 'green',
            color: 'white',
            icon: 'check'
        },
        {
            status: 'reviewer-reject',
            bg: 'red',
            color: 'white',
            icon: 'close'
        },
        //
        {
            status: 'approver',
            bg: '#eee',
            color: '',
            icon: 'clock'
        },
        {
            status: 'approved',
            bg: 'green',
            color: 'white',
            icon: 'check'
        },
        {
            status: 'approver-reject',
            bg: 'red',
            color: 'white',
            icon: 'close'
        },
    ];

    const {t} = useTranslation()

    const renderType = (type: string) => {
        if(type == 'r'){
            return <div className='badge badge-success'>{ t('reviewer') }</div>
        }
        if(type == 'a'){
            return <div className='badge badge-primary'>{ t('approver') }</div>
        }

        return <></>
    }

    return <div>
        <div className='my-4 pb-4 tracking-vt'>
            { [
                ...reviewers.map((item: any) => ({...item, type: 'r'})),
                ...approvers.map((item: any) => ({...item, type: 'a'})),
            ]?.map((reviewer: any, index: number) => {
                let status = bgStatuses?.find((item: any) => item.status == reviewer?.status);

                return <>
                    <div>
                        <div className='d-flex align-items-center'>
                            <div style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                background: status?.bg,
                                color: status?.color
                            }} className='d-flex align-items-center justify-content-center me-4'>
                                <i className={'fa fa-' + status?.icon}></i>
                            </div>
                            <div className='d-flex justify-content-between' style={{flex: 1}}>
                                <div>
                                    <div style={{
                                        fontSize: '16px',
                                        fontWeight: 'bold'
                                    }}>{[
                                        reviewer?.username,
                                        reviewer?.name,
                                    ].join(" - ")}</div>
                                    { reviewer?.approve_date && <i>{ reviewer?.approve_date }</i> }
                                </div>
                                <div>{renderType(reviewer?.type)}</div>
                            </div>
                        </div>
                    </div>
                    
                    {
                        index < (reviewers.length + approvers.length -1) && <>
                            <div className='tracking-vt-separator'></div>
                        </>
                    }
                </>
            }) }
        </div>
    </div>
}